export type Bonus = {
  id: string
  title: string
  tagline: string
  intro: string[]
  listLabel: string
  bullets: string[]
  flow?: { label?: string; steps: string[] }
  extraList?: { label: string; items: string[] }
  note?: string
  closing?: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Stretching Instructor Cueing & Communication Playbook',
    tagline: 'Know What to Say — Not Just What to Demonstrate',
    intro: [
      'A good stretching instructor does more than show positions.',
      'The right cue can completely change how a client understands and performs a stretch.',
    ],
    listLabel: 'This guide gives you professional coaching language for:',
    bullets: [
      'Setup',
      'Positioning',
      'Breathing',
      'Range',
      'Relaxation',
      'Alignment',
      'Transitions',
      'Corrections',
      'Modifications',
      'Progressions',
    ],
    extraList: {
      label: 'Includes:',
      items: [
        'Setup Cues',
        'Action Cues',
        'Alignment Cues',
        'Correction Cues',
        'Modification Cues',
        'Level-Up Cues',
      ],
    },
    closing: 'Clearer cues. Faster corrections. More confident teaching.',
  },
  {
    id: '02',
    title: 'Stretching Modifications & Progressions Handbook',
    tagline: 'One Class. Different Clients. One Clear System.',
    intro: [
      'Not every client needs the exact same version of every stretch.',
      'This guide helps you adapt stretching without creating an entirely different class for every person.',
    ],
    listLabel: 'Adjust:',
    bullets: [
      'Range',
      'Support',
      'Duration',
      'Position',
      'Tempo',
      'Stability',
      'Hold time',
      'Equipment',
      'Complexity',
    ],
    flow: {
      label: 'For major stretch families, use:',
      steps: ['Easier', 'Standard', 'Level up'],
    },
    extraList: {
      label: 'Ideal for:',
      items: [
        'Beginners',
        'Mixed-level groups',
        'Developing clients',
        'More experienced clients',
      ],
    },
    closing:
      'Modify faster. Progress intelligently. Keep the whole class moving.',
  },
  {
    id: '03',
    title: 'Stretching Class Planning & Sequencing System',
    tagline: 'Build Better Classes Without Starting From Zero',
    intro: [
      'Learn repeatable formulas for building balanced stretching classes.',
    ],
    listLabel: 'Includes structures for:',
    bullets: [
      '30-minute classes',
      '45-minute classes',
      '60-minute classes',
      'Lower-body focus',
      'Upper-body focus',
      'Full-body stretching',
      'Dynamic mobility',
      'Recovery',
      'Beginner classes',
      'Mixed-level classes',
    ],
    flow: {
      label: 'Learn how to organize:',
      steps: [
        'Warm-up',
        'Mobility',
        'Main stretching sequence',
        'Progression',
        'Cool down',
        'Reset',
      ],
    },
    closing:
      'Plan faster. Sequence better. Stop rebuilding everything every week.',
  },
  {
    id: '04',
    title: 'Stretching Safety, Contraindications & Instructor Decision Guide',
    tagline: 'Teach With Greater Awareness and Better Professional Boundaries',
    intro: ['Stretching should never be based on forcing greater range.'],
    listLabel: 'This guide helps instructors make better decisions around:',
    bullets: [
      'Range control',
      'Pain vs normal stretch sensation',
      'Joint positioning',
      'Excessive pressure',
      'Client communication',
      'Modification decisions',
      'When to reduce intensity',
      'When to stop a movement',
      'Professional teaching boundaries',
      'When appropriate referral may be needed',
    ],
    closing: 'Safety. Awareness. Better instructor decisions.',
  },
  {
    id: '05',
    title: 'Stretching Instructor Assessment & Progress Tracking Handbook',
    tagline: 'Make Progress Easier to See',
    intro: [
      'Help clients understand that progress is more than simply “touching the floor.”',
    ],
    listLabel: 'Evaluate and monitor:',
    bullets: [
      'Mobility',
      'Range',
      'Control',
      'Comfort',
      'Symmetry',
      'Position quality',
      'Movement confidence',
      'Class progression',
    ],
    note: 'Use simple assessment frameworks to make better programming decisions.',
    closing: 'Assess. Track. Progress.',
  },
]
